export default __webpack_public_path__ + "static/chromeExtension-806719254f69081297cde637ad5c56d7.svg";